import React from 'react';
import { BLACK, BORDER, GOLD, GOLD_DARK, GOLD_TINT, SURFACE_2, TEXT_MUTED } from '../../components/ProposalFlow/theme';
import type { LoopStep } from '../../types/pricingPlans';

// The Autopilot loop as a row of steps joined by arrows, with a return
// arrow from the last step back to the first so it reads as a cycle.
// Pure CSS/SVG; steps come from the API row's `detail.steps`.
const Arrow = () => (
  <svg width="22" height="14" viewBox="0 0 22 14" aria-hidden="true" style={{ flex: '0 0 auto', display: 'block' }}>
    <path d="M1 7h17M13 2l6 5-6 5" stroke={GOLD_DARK} strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export function LoopDiagram({ steps }: { steps: LoopStep[] }) {
  return (
    <div style={{ padding: '6px 4px 10px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
          gap: 8,
          overflowX: 'auto',
          paddingBottom: 6,
        }}
      >
        {steps.map((step, i) => (
          <React.Fragment key={step.label}>
            <div
              style={{
                flex: '1 1 0',
                minWidth: 130,
                border: `1px solid ${BORDER}`,
                borderTop: `3px solid ${GOLD}`,
                borderRadius: 10,
                background: i === 0 ? GOLD_TINT : SURFACE_2,
                padding: '10px 12px',
              }}
            >
              <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: 0.6, textTransform: 'uppercase', color: GOLD_DARK }}>
                {i + 1}
              </div>
              <div style={{ fontSize: 14, fontWeight: 700, color: BLACK, marginTop: 2 }}>{step.label}</div>
              <div style={{ fontSize: 12.5, color: TEXT_MUTED, marginTop: 4, lineHeight: 1.4, fontWeight: 400 }}>{step.text}</div>
            </div>
            {i < steps.length - 1 && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Arrow />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      {/* Return path: last step back to the first. */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" style={{ display: 'block', flex: '0 0 auto' }}>
          <path d="M20 12a8 8 0 1 1-2.3-5.7" stroke={GOLD_DARK} strokeWidth="2" fill="none" strokeLinecap="round" />
          <path d="M20 3v4.5h-4.5" stroke={GOLD_DARK} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span style={{ fontSize: 12.5, color: TEXT_MUTED, fontWeight: 400 }}>
          {steps[steps.length - 1].label} feeds the next {steps[0].label} — the loop runs on every analysis interval, per product.
        </span>
      </div>
    </div>
  );
}
